import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iLambdaStatusState {
    response: any;
    isLoading: boolean;
    message: string | null;
}

const initialState: iLambdaStatusState = {
    response: null,
    isLoading: false,
    message: "",
};

// DataList API 호출
export const lambdaCallStatusAPI = createAsyncThunk(
    "LAMBDA_CALL_STATUS",
    async (params: { lambda_name:string; group_name: string;  workflow_name :string; library_name: string; round_num: number}, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = `/tools/function-status/?group_name=${params.group_name}&library_name=${params.library_name}&lambda_name=${params.lambda_name}&round_num=${params.round_num}`;
            
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


// DataList Slice
export const lambdaStatusSlice = createSlice({
    name: "lambdaCallStatus",
    initialState,
    reducers: {
        // 결과 초기화 액션 추가
        resetLambdaStatus: (state) => {
            state.response = null;
            state.isLoading = false;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(lambdaCallStatusAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(lambdaCallStatusAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(lambdaCallStatusAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});


export const { resetLambdaStatus } = lambdaStatusSlice.actions;

export default lambdaStatusSlice.reducer;